// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "statusMessage-1TSr7";
var _4 = "statusMessage__text-3EHc4";
var _5 = "statusMessage__title-3vvwD";
export { _1 as "__esModule", _2 as "mobile", _3 as "statusMessage", _4 as "statusMessage__text", _5 as "statusMessage__title" }
export default { "__esModule": _1, "mobile": _2, "statusMessage": _3, "statusMessage__text": _4, "statusMessage__title": _5 }
